/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsLineHeight: {
  name: 'line-height';
  data: string;
} = {
  name: 'line-height',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 3a1 1 0 0 0 0 2h16a1 1 0 1 0 0-2H4Zm6.118 12-.224.447a1 1 0 1 1-1.788-.894l3-6a1 1 0 0 1 1.788 0l3 6a1 1 0 1 1-1.788.894L13.882 15h-3.764Zm1-2h1.764L12 11.236 11.118 13ZM3 20a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Z" fill="currentColor"/></svg>`,
};
